import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { Check, BookOpen, UserCircle, Terminal, Clock, Wrench } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    title: 'Guía Maestra Insta-Brand AI',
    desc: '(PDF de Implementación Inmediata)',
    icon: <BookOpen className="text-brand-cyan" size={24} data-id="element-247" />
  }, {
    title: 'El Manual de Identidad Sintética',
    desc: 'Cómo crear tu "Avatar de Autoridad" persistente',
    icon: <UserCircle className="text-brand-cyan" size={24} data-id="element-248" />
  }, {
    title: 'Diccionario de Prompts Maestros',
    desc: 'Copia y pega las instrucciones para guiones virales',
    icon: <Terminal className="text-brand-cyan" size={24} data-id="element-249" />
  }, {
    title: 'El Flujo de Trabajo de 60 Minutos',
    desc: 'Sistema paso a paso para crear una semana de contenido en una hora',
    icon: <Clock className="text-brand-cyan" size={24} data-id="element-250" />
  }, {
    title: 'Glosario de Herramientas Pro',
    desc: 'El stack tecnológico exacto (Gratis y Pago) para resultados nivel Hollywood',
    icon: <Wrench className="text-brand-cyan" size={24} data-id="element-251" />
  }];
  return <Section className="bg-brand-darker/80 border-y border-white/5" data-id="element-252">
      <div className="max-w-5xl mx-auto" data-id="element-253">
        <div className="text-center mb-16" data-id="element-254">
          <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-255">
            Lo Que Recibes
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-brand-cyan to-brand-purple mx-auto rounded-full" data-id="element-256" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-257">
          {items.map((item, index) => <motion.div key={index} className={`glass-card p-6 rounded-xl border-brand-cyan/20 hover:border-brand-cyan/50 transition-colors flex gap-4 items-start ${index === items.length - 1 ? 'md:col-span-2 md:w-1/2 md:mx-auto' : ''}`} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} data-id="element-258">
              <div className="p-3 bg-brand-cyan/10 rounded-lg shrink-0" data-id="element-259">
                {item.icon}
              </div>
              <div data-id="element-260">
                <h3 className="text-xl font-bold text-white mb-1 flex items-center gap-2" data-id="element-261">
                  {item.title}
                </h3>
                <p className="text-brand-gray" data-id="element-262">{item.desc}</p>
              </div>
              <Check className="text-brand-cyan ml-auto shrink-0 opacity-50" size={20} data-id="element-263" />
            </motion.div>)}
        </div>
      </div>
    </Section>;
}